import api from '~/plugins/apiClient';
import { formatApiUrl } from '~/plugins/apiClient/utils';
import { ApiHandler, ApiHandlerWithArgs, ApiHandlerWithData, ApiResponseContext } from '~/plugins/apiClient/_types';
import {
    NotificationDetail,
    NotificationDetailSchema,
    NotificationList,
    NotificationListSchema,
    NotificationStatus,
    NotificationStatusSchema,
} from './_types';
import { transformZodSchemaFn } from '~/plugins/zod/utils';
import { FetchListOptions, PaginationMeta, PaginationMetaSchema } from '../_types';
import { transformFetchListOptionsToQuery } from '../_transformers';
import { NotificationAction } from '~/enums/_types';

// > Endpoint prefix
const apiEndpointPrefix = 'notifications';

export const fetchNotificationsRequest: ApiHandlerWithArgs<
    FetchListOptions,
    ApiResponseContext<NotificationList | null, null, PaginationMeta>
> = async (opt) => {
    const url = formatApiUrl(apiEndpointPrefix);
    return api.get(url, {
        transform: transformZodSchemaFn(NotificationListSchema, url),
        transformMeta: transformZodSchemaFn(PaginationMetaSchema, url),
        params: transformFetchListOptionsToQuery(opt),
    });
};

export const fetchNotificationStatusRequest: ApiHandler<
    ApiResponseContext<NotificationStatus | null, null>
> = async () => {
    const url = formatApiUrl(apiEndpointPrefix, 'info');
    return api.get(url, {
        transform: transformZodSchemaFn(NotificationStatusSchema, url),
    });
};

export const patchNotificationActionRequest: ApiHandlerWithData<
    { id: string; action: NotificationAction },
    ApiResponseContext<NotificationDetail>
> = async ({ id, action }) => {
    const url = formatApiUrl(apiEndpointPrefix, `${id}/${action}`);
    return api.patch(url, {
        transform: transformZodSchemaFn(NotificationDetailSchema, url),
    });
};
